<template>
  <div class="traffic-page">
    <div class="traffic-content">
      <img :src="traffic1" alt="" class="traffic-img traffic-img-1" />
      <img :src="traffic2" alt="" class="traffic-img" />
      <img :src="traffic3" alt="" class="traffic-img" />
      <img :src="traffic4" alt="" class="traffic-img" />
      <img :src="traffic5" alt="" class="traffic-img" />
      <img :src="traffic6" alt="" class="traffic-img" />
      <img :src="traffic7" alt="" class="traffic-img" />
    </div>
    <!-- 返回按钮 -->
    <!-- 返回按钮 -->
    <div class="back-btn-wrap">
      <van-button type="primary" round @click="goBack" class="back-btn">返  回<br />
                  <span class="btn-en">Back</span></van-button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import traffic1 from '@/assets/traffic1.png'
import traffic2 from '@/assets/traffic2.png'
import traffic3 from '@/assets/traffic3.png'
import traffic4 from '@/assets/traffic4.png'
import traffic5 from '@/assets/traffic5.png'
import traffic6 from '@/assets/traffic6.png'
import traffic7 from '@/assets/traffic7.png'

const router = useRouter()
const store = useStore()

const mainColor = computed(() => store.state.mainColor)

const goBack = () => {
  router.back()
}
</script>

<style lang="less" scoped>
.traffic-page {
  min-height: 100vh;
  background-image: url('~@/assets/deepbg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;

  .traffic-content {
    flex: 1;
    padding: 16px;
  }

  .traffic-img {
    width: 100%;
    display: block;
    margin: 10px 0;
  }

  .traffic-img-1 {
    width: 54%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }

  .back-btn-wrap {
    text-align: center;
    margin-top: 8vw;
    padding-bottom: 5vw;

    .van-button {
      width: 50vw;
    }

    .back-btn {
      background-color: #fff !important;
      color: #003df2 !important;
      border: 1px solid #003df2 !important;
      border-radius: 10px !important;
    }
  }
}

@media screen and (min-width: 768px) {
  .traffic-page {
    max-width: 800px;
    margin: 0 auto;

    .back-btn-wrap .van-button {
      width: 200px;
    }
  }
}
</style>
